// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3lMgz","label":"CategoryService_label__3mz9q","location":"CategoryService_location__2E2G9"};